import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditAttributesIcon from '@material-ui/icons/EditAttributes';
import MuiEditIcon from '@material-ui/icons/Edit';
import MuiDoneIcon from '@material-ui/icons/Done';
import MuiBlockIcon from '@material-ui/icons/Block';

const styles = theme => ({
  buttonDone: {
    color: theme.palette.primary.success,
  },
  buttonCancel: {
    // color: theme.palette.primary.error,
  },
  hiddenButton: {
    visibility: 'hidden',
    width: 40,
  },
});

const RowEditButtons = props => {
  const { classes, editing, onEditChange, editIcon, disabled } = props;

  // Listeners

  const handleEditClick = () => onEditChange(true);
  const handleCancelClick = () => onEditChange(false);

  return (
    <>
      {!editing ? (
        <>
          <MuiIconButton disabled={disabled} className={classes.hiddenButton} />
          <MuiIconButton onClick={handleEditClick}>
            {editIcon === 'table' ? <MuiEditIcon /> : <MuiEditAttributesIcon />}
          </MuiIconButton>
        </>
      ) : (
        <>
          <MuiIconButton disabled={disabled} className={classes.buttonDone} type="submit">
            <MuiDoneIcon />
          </MuiIconButton>
          <MuiIconButton disabled={disabled} className={classes.buttonCancel} onClick={handleCancelClick}>
            <MuiBlockIcon />
          </MuiIconButton>
        </>
      )}
    </>
  );
};

RowEditButtons.defaultProps = {
  editIcon: 'row',
};

export default withStyles(styles)(RowEditButtons);
